export default "__VITE_ASSET__1d75641f__"